import { Auth } from 'aws-amplify';

import { isProduction } from 'utils/envUtils';
import { logError } from 'utils/sentryUtils';

const PR_REVIEW_PATTERN = /^pr-\d+$/;
let baseURL = '';

if (!isProduction()) {
    const apiBackend = (import.meta.env.VITE_REACT_APP_BACKEND ?? '').trim();

    if (apiBackend) {
        if (PR_REVIEW_PATTERN.test(apiBackend)) {
            baseURL = `https://ecommerce-${apiBackend}.k8s-prod.misfitsmarket.io`;
        } else {
            baseURL = `https://${apiBackend}-dev.misfitsmarket.com`;
        }
    }
}

const defaultOptions = {
    headers: {
        'Content-Type': 'application/json',
    },
};

const mmFetch = async (url, options = {}) => {
    const headers = { ...defaultOptions.headers, ...options.headers };

    try {
        const session = await Auth.currentSession();
        const bearerToken = session?.getIdToken()?.getJwtToken();
        if (bearerToken && !headers.Authorization) {
            headers.Authorization = `Bearer ${bearerToken}`;
        }
    } catch (error) {
        logError(error);
        // Authorization header will not be included if session retrieval fails
    }

    const isFormDataBody = typeof FormData !== 'undefined' && options?.body instanceof FormData;
    if (isFormDataBody) {
        delete headers['Content-Type'];
    }

    return fetch(`${baseURL}/${url}`, { ...defaultOptions, ...options, headers });
};

export { mmFetch };
